var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9903 4.15918V12.5967H12.2637V4.15918H6.9903ZM11.209 8.06894L11.0546 8.22343C10.4824 8.79555 10.1544 9.58766 10.1544 10.3967V11.0146H9.09967V10.3967C9.09967 9.38524 9.48172 8.39345 10.1544 7.64102V7.32324H9.09967V7.85059H8.04498V6.26855H11.209V8.06894Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.627014 0.995117H18.627V3.10449H0.627014V0.995117Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.627014 13.6514H18.627V15.7607H0.627014V13.6514Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93561 4.15918H0.627014V12.5967H5.93561V4.15918ZM4.88092 8.06894L4.72643 8.22343C4.15431 8.79555 3.82623 9.58766 3.82623 10.3967V11.0146H2.77155V10.3967C2.77155 9.38524 3.15359 8.39345 3.82623 7.64102V7.32324H2.77155V7.85059H1.71686V6.26855H4.88092V8.06894Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3184 12.5967H18.627V4.15918H13.3184V12.5967ZM14.3731 6.26855H17.5372V8.06894L17.3827 8.22343C16.8106 8.79555 16.4825 9.58766 16.4825 10.3967V11.0146H15.4278V10.3967C15.4278 9.38524 15.8098 8.39345 16.4825 7.64102V7.32324H15.4278V7.85059H14.3731V6.26855Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlots);
export default __webpack_public_path__ + "static/media/slots.ec046834b36d9d3f767d79065efdf3a0.svg";
export { ForwardRef as ReactComponent };